export const getUserPreferences = () =>
    `query getUserPreferences {
        appSettingsConfig {
            tenantConfig {
                zoneId
            }
            trainingProgramsConfig {
                id
                maxTrainings
                applicableLocationsConfig {
                    enableApplicableLocations
                }
                trainerAppConfig {
                    allowActions
                    enableTrainerSignature
                    enableOperatorSignature
                    enableUploadEvidence
                    taskTypesWithEvidence {
                        taskType
                        evidenceRequired
                    }
                }
            }
        }
        userPreferences {
            userPreferencesId
            rowsPerPage {
                operators
                devices
                trainings
            }
            operatorReportHeader
            filters {
                filterId
                filterName
                type
                frontendData
                queryData
            }
            language {
              languageName
            }
            viewFields {
                viewFieldId
                viewType
                fields {
                  fieldId
                  field
                  visible
                  pinned
                  columnIndex
                }
              }
        }
    }`;

export const getOperatorFilterAlarmsQuery = () =>
    `query getOperatorFilterAlarms {
        retrieveSavedViewAlarms {
          alarms {
            count
            type
          }
          identifier
          totalOperators
        }
      }`;

export const getDeviceFilterAlarmsQuery = () =>
    `query getDeviceFilterAlarms {
        deviceAlarmNumbers {
          alarms {
            count
            type
          }
          identifier
          totalDevices
        }
      }`;

export const removeFilterFromUserById = () =>
    `mutation removeFilterFromUserById($filterId: UUID!) {
        removeFilter(filterId: $filterId)
    }`;

export const saveUserFilter = () =>
    `mutation saveUserFilter($userPreferencesId: UUID, $filterName: String!, $filterType: UserFilterType, $frontendData: String!, $queryData: String!) {
        saveFilter(filter: { userPreferencesId: $userPreferencesId, filter: {filterName: $filterName, type: $filterType, frontendData: $frontendData, queryData: $queryData}}) {
            filterId
        }
    }`;

export const updateUserFilter = () =>
    `mutation updateUserFilter($userPreferencesId: UUID!, $filterId: UUID!, $filterName: String!, $frontendData: String!, $queryData: String!) {
        updateFilter(filter: { userPreferencesId: $userPreferencesId, filter: {filterId: $filterId, filterName: $filterName, frontendData: $frontendData,  queryData: $queryData}})
    }`;

export const saveTableRowsPerPage = () => `
    mutation savePageSize($rowsPerPage: RowsPerPageInput!) {
        saveRowsPerPage(rowsPerPage: $rowsPerPage)
    }
`;
